export const DEFAULT_MIGRATION_PATH = "./migrations";
export const DEFAULT_MIGRATION_TABLE = "d1_migrations";
export const LOCATION_CHOICES = ["weur", "eeur", "apac", "oc", "wnam", "enam"];
export const JURISDICTION_CHOICES = ["eu", "fedramp"];
export const D1_DOCS_URL = "https://developers.cloudflare.com/d1/";
